export const CHAT_FILTERS = [
  { label: 'Общая информация', key: 'use_source_common', permission: 'business' },
  { label: 'Настройки ИИ', key: 'use_source_ai_config', permission: 'ai-settings' },
  { label: 'ТЗ', key: 'use_specification', permission: 'technical-task' },
  { label: 'Jira', key: 'use_source_jira', permission: 'jira' },
  { label: 'Confluence', key: 'use_source_confluence', permission: 'confluence' },
  { label: 'Git', key: 'use_source_gitLab', permission: 'git' },
  { label: 'Яндекс трекер', key: 'use_source_yandex_tracker', permission: 'yandex' },
  { label: 'Яндекс Вики', key: 'use_source_yandex_wiki', permission: 'yandex' },
];
